<div class="counter__cont" [style.background-color]="backgroundColor">
  <div class="counter__icon">
    <i [class]="icon"></i>
  </div>
  <div class="counter__label">{{ literal | translate }}</div>
  <div class="counter__number">{{ counter }}</div>
</div>
